export default "__VITE_ASSET__X8ZBNHFr__"